import { render, staticRenderFns } from "./TherapyHero.vue?vue&type=template&id=4d0edd66&lang=true&"
import script from "./TherapyHero.vue?vue&type=script&lang=js&"
export * from "./TherapyHero.vue?vue&type=script&lang=js&"
import style0 from "./TherapyHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports